import { Component, input, output } from '@angular/core';

import type { Candidate } from '@recruitee/candidate-types';
import { IconComponent } from '@recruitee/user-interface';

import { RevealButtonComponent } from '../reveal-button/reveal-button.component';

@Component({
  selector: 'rt-anonymous-candidate-empty-state',
  imports: [IconComponent, RevealButtonComponent],
  templateUrl: './anonymous-candidate-empty-state.component.html',
  styleUrl: './anonymous-candidate-empty-state.component.less',
})
export class AnonymousCandidateEmptyStateComponent {
  public message = input.required<string>();
  public candidate = input<Candidate>();
  public skipRevealConfirmation = input<boolean>(false);
  public canReveal = input<boolean>(false);

  public toggleDataVisibility = output<boolean>();
  public saveSkipRevealConfirmation = output();
}
